import React from 'react'
import Hero from '../components/Hero'
import VideoSection from '../components/VideoSection'
import Services from '../components/Services'
import StockSlides from '../components/StockSlides'
import Marque from '../components/Marque'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'

const Home = () => {
  const {t, i18n} = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <div className='overflow-hidden'>
        <Hero 
        name="home"
        motherclassName={`${isRTL ? 'pr-16 xxxl:pr-20' : 'pl-16 xxxl:pl-20' }   lg:pt-6 flex flex-row`}
        className1='w-full flex gap-2 items-center justify-center h-full'
        className2='text-primary02 flex flex-col justify-center  w-1/2'
        className3='w-1/2'
        classText1='text-[35px] xl:text-[40px] xxl:text-[48px] xxxl:text-[55px] xxxxl:text-[65px] xxl:w-[90%] xxxl:w-[80%]' 
        classText11='lg:text-[25px] xl:text-[30px] xxxl:text-[35px]' 
        classText12='lg:text-[18px] xl:text-[20px] xxl:text-[23px] xxxl:text-[28px] xxxxl:text-[30px]' 
        classText2='text-[20px] lg:text-[18px] xl:text-[23px] xxxl:text-[27px] xxxxl:text-[35px]'
        classText3='text-[25px] xl:text-[30px] xxl:text-[35px] xxxl:text-[40px] xxxxl:text-[45px]'
        cljustify='flex flex-col gap-3 w-full'
        padd='p-6' />
        <VideoSection/>
        <Services
          name="about"
          // Distribution classes
          padd='px-20 xxxl:px-28'
          motherclassName1=' flex flex-row lg:gap-10 xl:gap-12 xxl:gap-16 xxxl:gap-20'
          className11='w-full flex gap-2 items-center justify-center h-full'
          className21=' w-1/2'
          className31='w-1/2 flex justify-end'
          classmarginbottom1='mb-10 xxl:mb-12 xxxl:mb-14 xxxxl:mb-16' 
          classbottom1='-bottom-10 xl:-bottom-12 xxxl:-bottom-14 xxxxl:-bottom-16' 
          classText11='lg:text-[20px] xl:text-[21px] xxl:text-[22px] xxxl:text-[30px] xxxxl:text-[40px] font-bold'
          classwidth1='lg:w-[85%] xxl:w-[82%] xxxl:w-[85%] xxxxl:w-[75%]'
          classSectionText11='lg:text-[32px] xxl:text-[35px] xxxl:text-[38px]'
          classSectionText21='text-[25px] xl:text-[28px] xxl:text-[32px] xxxl:text-[35px]'
          classSectionText31='text-[22px] xl:text-[25px] xxl:text-[27px]'
          classSectionText41='lg:text-[17px] xl:text-[21px] xxxl:text-[25px]'
          // Stock classes
          motherclassName='flex flex-row aspect-[16/6] justify-center items-center'
          className1='w-[45%] h-full'
          className2={`w-[55%] h-full bg-primary ${isRTL ? 'pr-8 xl:pr-14 xxl:pr-20 xxxl:pr-28 xxxxl:pr-36' : 'pl-8 xl:pl-14 xxl:pl-20 xxxl:pl-28 xxxxl:pl-36'} py-12 flex flex-col items-center justify-center lg:gap-8 xl:gap-12 xxl:gap-20 xxxxl:gap-28`}
          className3='lg:gap-4 xl:gap-6  xxl:gap-10 xxxxl:gap-14'
          className4='gap-3 xl:gap-4 xxl:gap-6 pl-4 xxl:pl-8 xxxxl:pl-12'
          classiconpadd='p-2 xxl:p-4 xxxxl:p-6' 
          classicon='w-16 xxl:w-20 xxxxl:w-24' 
          classGap1='gap-2 xxl:gap-4 xxxxl:gap-6'
          classAfter='relative after:absolute after:content-[""] after:w-full after:h-[1px] after:bg-white/50 after:left-0 after:-bottom-6 xxl:after:-bottom-10 xxxxl:after:-bottom-12'
          classAbsolute={`top-[calc(100%+24px)] xxl:top-[calc(100%+40px)] xxxxl:top-[calc(100%+44px)] ${isRTL ? '-left-[70%]' : '-right-[35%]'}  h-[200px] xl:h-[300px] xxl:h-[350px] xxxxl:h-[420px]`}
          classHeader1='text-[25px] xl:text-[30px] xxl:text-[35px] xxxxl:text-[45px]'
          classText1='text-[15px] xl:text-[18px] xxl:text-[23px] xxxxl:text-[30px]'
          classHeader2='text-[25px] xl:text-[28px] xxl:text-[32px] xxxxl:text-[40px]'
          classHeader3='text-[18px] lg:text-[22px] xxl:text-[25px] xxxxl:text-[30px]'
          // rooms classes
          padd2='px-20 lg:px-28 xxl:px-36 xxxl:px-44'
          motherclassName2='flex flex-row aspect-[16/4]  justify-center items-center gap-8'
          className12='w-1/2 flex flex-col justify-center items-center gap-6'
          className22=' py-2 px-4'
          className32=' w-36'
          className42='lg:text-[30px] xxl:text-[35px] xxxl:text-[45px]'
          className52='w-[80%] lg:text-[17px] xxl:text-[20px] xxxl:text-[25px]'
          />
          <StockSlides 
            name="stock"
            motherclassName={`flex flex-row aspect-[16/5] justify-center items-center ${isRTL ? 'pr-20 lg:pr-28 xxl:pr-36 xxxl:pr-44' : 'pl-20 lg:pl-28 xxl:pl-36 xxxl:pl-44'}  mt-20`}
            className1='w-1/3 h-full  flex flex-col justify-center items-start lg:gap-4 xl:gap-5 xxl:gap-6 xxxl:gap-8 pr-3'
            className2='lg:text-[25px] xl:text-[30px] xxl:text-[35px] xxxl:text-[40px]'
            className3='lg:text-[18px] xl:text-[20px] xxl:text-[22px] xxxl:text-[25px] leading-[35px]'
            className4='gap-3 text-[25px] leading-[40px]'
            className5='w-2/3 h-full pl-[50%] rounded-3xl relative'
          />
          <Marque 
            name="marque"
            padd='px-20 lg:px-28 xxl:px-36 xxxl:px-44 w-full aspect-[16/2] mt-20 mb-10'
            motherclassName='w-full h-full flex flex-row  justify-around items-center bg-primary02'
            className1='lg:text-[30px] xl:text-[35px] xxl:text-[40px] xxxl:text-[45px]'
            className2=''
          />
          <Footer/>
    </div>
  )
}

export default Home